function unique(array) {
  return $.grep(array, function(el, index) {
    return index === $.inArray(el, array);
  });
}

notification_bar = {
  init:function(){
    if(!$.cookie('notification_bar__pi123321123')){
      $.cookie('notification_bar__pi123321123', true, {expires: 31});
      $('.f-notification-bar').addClass('active');
      $(document).on('click','.f-notification-bar__close',function(){
        $('.f-notification-bar').removeClass('active');
      });
    };
  },
};

//notifcation bar
header_notification_bar = {
  init:function(multipleblocks){
    if(multipleblocks === true){
    header_notification_bar.slider();
    };
    var $bar = $('.notification-bar'),
        $items = $('.m-header--nb_true,.dd-menu--nb_true,main');       
    $(window).on('load resize scroll',function(){
      if($(window).scrollTop() > $bar.height()){
        $items.addClass('nb-is-scrolled');
      }else{
         $items.removeClass('nb-is-scrolled');
      };
    });
  },
  slider:function(){
    $('.notification-bar').flickity({
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      //autoPlay:5000
    });
  }
};

dropdown = {
  bind:function(){ 
    //show mobile nav  
    $(document).on('click','.m-header__icon-link--burger',function(e){
      e.preventDefault();
      var $t = $(this);
      if($t.hasClass('is-active')){
        $t.removeClass('is-active');
        $('.m-header__m-nav').removeClass('is-active');
        $('body').removeClass('body--mobile-nav__open');
      }else{
        $t.addClass('is-active');
        $('.m-header__m-nav').addClass('is-active');
        $('body').addClass('body--mobile-nav__open');
      };
    });
    //regular nav     
    $('.m-header__init_link').hoverIntent(function(){
      dropdown.l1_close();
      dropdown.l1_open($(this).parent('[data-hasdropdown]'));
    },function(){});
    
    $('[data-hasdropdown].is-active').hoverIntent(function(){},function(){
      dropdown.l1_close();
    });
  
    $('.m-header__m-nav').hoverIntent(function(){},function(){
      dropdown.l1_close();
    });
    
    $('[data-hasdropdownl2]').hoverIntent(function(){
      dropdown.l2_open($(this));
    },function(){});
   
     //mobile nav
   
    $(document).on('click','[data-hasdropdown] .m-header__init_link',function(e){
      if($(window).width() < 1024){
        e.preventDefault();
        dropdown.l1_open($(this).parent('[data-hasdropdown]'));
      };
    });
    
    $(document).on('click','[data-hasdropdown].is-active a.m-header__init_link',function(e){
      dropdown.l1_close();
    });
    $('.dd-menu__main-title').on('click',function(){
      var el = $(this).parents('.dd-menu--l__l2-wrap');
      if(el.hasClass(('is-active'))){
        dropdown.l3_close(el);
      }else{
        dropdown.l3_open(el);
      };
    });
  },  
  l1_open:function(el){  
    el.addClass('is-active');
    var tagret = el.attr('data-hasdropdown'),
        targetel = $('[data-dropdown_id="'+tagret+'"]');
    targetel.show();
  },
  
  l1_close:function(){
    $('.dd-menu').hide();
    $('[data-hasdropdown]').removeClass('is-active');
  },
  l2_open:function(el){
     var target = el.attr('data-hasdropdownl2');
     el.addClass('active').siblings().removeClass('active');
     el.parents('.dd-menu').find('.dd-menu--l__l2-wrap').hide().filter('[data-dropdownl2_id="'+target+'"]').show();
  },
  
  l3_open:function(el){
    el.addClass('is-active').siblings('.dd-menu--l__l2-wrap').removeClass('is-active');
  },
  l3_close:function(el){
    el.removeClass('is-active').siblings('.dd-menu--l__l2-wrap').removeClass('is-active');
  },
};

full_page_slideshow = {
  init:function(){
    $('.full-page-slideshow__slides').flickity({
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: false,
      //bgLazyLoad: 4
    });
  }
};

qnt_input = {
  bind:function(){
    $(document).on('click','.qnt_input span', function() {
      var t = $(this),
          a = t.closest('.qnt_input').find('input'),
          b = a.val(),
          b = parseInt(b, 10),
          c = parseInt(a.attr('min'),0),
          d = parseInt(a.attr('max'),0),
          x = b+1,
          y = b-1  
      if(t.hasClass('plus')){ 
        if(b <= d-1 || d === null || !d){
          a.val(x).trigger('change');
        };
      }else{
        if(y > 0){
          a.val(y).trigger('change');
        };
      };   
    });
  }
};

index__cta = {
  init:function(){
    $('.cta-grid__item-container').flickity({
      cellAlign: 'left',
      contain: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded:true,
      draggable: false,
      //bgLazyLoad: 4
    });
  }
}
p_carousel = {
  init:function(){
    $('.p-carousel__items').flickity({
      cellAlign: 'left',
      contain: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded:true,
      draggable:false,
      //bgLazyLoad: 4
    });
  }
};

f_video = {
  init:function(){
    video.bind();
    $('.index__featured_video ul').flickity({
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: false,
      //bgLazyLoad: 4
    });
  }
}

b_carousel = {
  init:function(){
    $('.b-slider').flickity({
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      autoPlay:3000,
      draggable: false,
    });
  }
};

product = {
  init:function(){
    product.accordian()
    $(document).on('click','[data-product="reviews"]',function(e){
      e.preventDefault();
      $('a[data-get_section="product__reviews"]').trigger('click');
    });
    //wrap any iframes
    $('iframe[src*="youtube"],iframe[src*="vimeo"]').each(function(){
      if(!$(this).parent().hasClass()){
        $(this).wrap('<div class="video-wrapper"></div>')
      };
    });
  },
  
  image_slider:function(){
    var $main = $('.p-main__featured-image').flickity({
      pageDots:false,
      prevNextButtons:true,
      wrapAround: true,
      imagesLoaded:true,
      draggable: false,
    });
    var $thumbs = $('.p-main__image-thumbs').flickity({
     cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      freeScroll: false,
      imagesLoaded:true,
      wrapAround: false,
      draggable: false,
    });
    var flkty = $main.data('flickity');
    $(document).on('click','.p-main__image-thumbs li',function(){
      $main.flickity('select',$(this).index());
      $(this).addClass('is-active').siblings().removeClass('is-active');
    });
    $main.on('settle.flickity', function() {
      $('.p-main__image-thumbs li').eq(flkty.selectedIndex).addClass('is-active').siblings().removeClass('is-active');
    });
  },
  accordian:function(){
    $('[data-get_section]').click(function(e){
      e.preventDefault();
      $(this).addClass('is-active').siblings('a').removeClass('is-active');
      var get = $(this).attr('data-get_section');
      $('.p-meta__content_block').hide().filter('[data-is_section="'+get+'"]').show();
    });
  },
  meta_slider:function(){
    var meta_slider = $('.p-meta__content').flickity({
      prevNextButtons:false,
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      freeScroll: false, 
      adaptiveHeight: true
    });
    var pager = $('.p-meta__titles a'),
        flkty = meta_slider.data('flickity');
    
    meta_slider.on('select.flickity', function() {
      pager.filter('.is-active').removeClass('is-active');
      pager.eq(flkty.selectedIndex).addClass('is-active');     
    });

    pager.on('click',function(e) {
      e.preventDefault();
      var index = $(this).index();
      meta_slider.flickity('select', index);
    });
    
    $(window).load(function(){
      meta_slider.flickity('resize');
    });
  },
  update_inventory:function(form){
    $.getJSON('/cart.js', function(cart, textStatus) {
        $.each(cart.items,function(k,v){
        var el = $('[data-id="'+v.id+'"]');
          if(el.length > 0){
            var inv  = parseInt(el.attr('data-inventory_init'),0) - v.quantity;
            el.attr('data-inventory_current',inv);
          };
      });
      product.update_form(form);
    });
  },
  update_form:function(form){
    
    var $btn = form.find('.button--add-to-cart'),
        $input = form.find('[name="id"]');
    if($input.is('select')){
      $input = $input.find('option:selected')
    };
    var $qty = form.find('[name="quantity"]'),
        inv = $input.attr('data-inventory_current'),
        price = $input.attr('data-price'),
        price_exc_vat = $input.data('price_exc_vat');
    //update inventory
    if(inv != null){
      $qty.attr('max',inv).val(1);
      if(inv <= 0){
        $btn.attr('disabled','disabled').find('.button__content').text('Out of stock');
        $('[data-product="outofstock"]').show();
      }else{
        var default_text = $btn.find('.button__content').attr('data-cart__default-text');
        $btn.attr('disabled',false).find('.button__content').text(default_text);
        $('[data-product="outofstock"]').hide();
      };
    };
   
    /**/
    form.find('[data-price="main"]').html(price);
    form.find('[data-price="exvat"]').html(price_exc_vat + ' ex VAT');
    Currency.convertAll(defaultCurrency, Currency.currentCurrency);
  },
  no_variant:function(form){
    var $btn = form.find('.button--add-to-cart');
     $btn.attr('disabled','disabled').find('.button__content').text('Unavailable');
  },
};

product_select = {
  build:function(json,form,update_images){
    product_select.json = json;
    product_select.bind();
    var option,option__index,option__variants;
    $.each(json.options,function(i,v){
      option = v,
      option__index = i+1;
      option__variants = unique($.map(json.variants,function(value,index){
        return value["option"+option__index];
      }));
      var template = '<div class="p-main__form-row p-main__form-row_-variants flex row-wrap align-center justify-space">\
					  <div class="block-6/12 @mobile_mobile-portrait__block-12/12"><label>'+option+'</label></div>\
					  <div class="block-6/12 @mobile_mobile-portrait__block-12/12">'+product_select.get_element(option__variants,option,option__index-1)+'</div>\
  					  </div>'                      
      form.find('.p-options').append(template);                 
    });
    //update inventory after init
    product.update_inventory(form);
    if(update_images != null){
      form.find('.p-select-main').change(function(){
        var src = $(this).find("option:selected").attr('data-var_img_src');
        if(src != null || src != ""){
          if(update_images == "slide"){
            var slide_index = $('img[data-variant_src ="'+src+'"]');
            //console.log(src,slide_index)
            if(src && src!=""){
              slide_index = $(slide_index[0]).parent('li').index();
              console.log(slide_index)
              $('.p-main__featured-image').flickity( 'select', slide_index);
            };   
          };
        };
      });
    };
  },
  get_element:function(variants,option,index){
    var $el;
    if(variants.length <= 1){
      $el = '<input type="hidden" data-option__name="'+option+'" data-option__index="'+index+'" value="'+variants[0]+'" readonly><span>'+variants[0]+'</span>';
    }else{
      var str = "";
      $.each(variants,function(k,v){
        str += "<option value='"+v+"'>"+v+"</option>"
      });
      $el = '<select data-option__name="'+option+'" data-option__index="'+index+'">'+str+'</select>'  
    };       
    return $el
  },
  get_selected_variant:function(form){
    var map = $('[data-option__name]').map(function(i,el){
      return $(el).val();
    }).get();
    var id = $.grep(product_select.json.variants,function(v,k){
      return v.options[0] === map[0] &&  v.options[1] === map[1] &&  v.options[2] === map[2];
    });
    if(id.length > 0){
      var id = id[0].id;
      form.find('[name="id"]').val(id).trigger('change');
      product.update_form($('#product_main'));
    }else{
      product.no_variant($('#product_main'));
    };
  },
  bind:function(){
    ///change event for split 
    $(document).on('change','[data-option__name]',function(){
      product_select.get_selected_variant($(this).parents('form'));
    });
  },
};

//cart 
ajax_cart = {
  bind:function(){
    //submit add to cart form
    $(document).on('submit','[action="/cart/add"]',function(e){
      e.preventDefault();
      ajax_cart.addToCart($(this));
    });
  },

  animate_add_to_cart:function(){
   
  },
  
  addToCart:function(form){
    var data = {
      quantity:form.find('[name="quantity"]').val(),
      id: form.find('[name="id"]').val()
    };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) { 
        form.find('.button').addClass('is-success').prop('disabled','disabled');
        //update inventory
        product.update_inventory(form);
        ajax_cart.update_cart();
        setTimeout(function(){
          form.find('.button').removeClass('is-success').prop('disabled',false);
        },2000);
      },
      error:function(data,b){
        product.update_inventory(form); 
      }
    });
  },
  update_cart:function(){
    $.getJSON('/cart.js', function(cart, textStatus) {
      $('[data-cart="count" ]').text(cart.item_count)
      console.log(cart)
    });
  },
};

customer = {
  adresses:function(){
    var select = $('[name="address[country]"]');
    select.each(function(){
      var def = $(this).attr('data-default');
      $(this).val(def);
    });
    

    $('[data-delete-address]').click(function(e){
      e.preventDefault();
       Shopify.CustomerAddress.destroy($(this).attr('data-delete-address'), '')
    });
    
    $('[data-id]').click(function(e){
      e.preventDefault();
      $('.ac__adress_block').hide().filter('[data-address="'+$(this).attr('data-id')+'"]').show();
    });
    
    $('[data-address="cancel"]').click(function(e){
      e.preventDefault();
      $('.ac__adress_block').hide().filter('[data-address="new"]').show();
    });
  }
};

modal = {
  bind:function(){
    $('.mdl__close-ico').click(function(e){
      e.preventDefault();
      modal.close();
    });
  },
  open:function(target){
    $('.mdl__content').hide().filter(target).show();
    $('.mdl').fadeIn(200);
  },
  close:function(){
    $('.mdl').fadeOut(200);
    if(video.modal_player && video.modal_player != null){
      video.modal_player.pauseVideo();
    }
  },
  build:function(target,callback){
  },
};
video = {
  bind:function(){
     $(document).on('click','[data-modal_video_id]',function(e) {
       e.preventDefault();
       video.build_modal($(this).attr('data-modal_video_id'),'mdl-video');
     });
  },
  build_modal:function(id,target){
    console.log(target)
    if(!video.modal_player || video.modal_player === null){
      video.modal_player = new YT.Player(target, {
        height: '720',
        width: '1280',
        playerVars: {
          'PlaybackQuality': 'highres',
          'rel': 0,
          'loop': 0,
          'controls': 1,
          'showinfo': 0,
          'enablejsapi ': 1,
          'wmode': 'opaque',
          'playlist': id
        },
        videoId: id,
        events: {
          'onReady': function() {
            video.modal_player.playVideo();
            modal.open('#'+target);
          }
        }
      });
    }else{
      modal.open('#'+target);
      video.modal_player.cueVideoById({videoId:id});
      video.modal_player.playVideo();
    };
  },

};

ajax_form = {
  bind:function(el,callback){
    el.validate();
    el.ajaxChimp({
      url:el.attr('action'),
      callback:function(data,datab){
        if(data.msg != "0 - Please enter a value"){
          el.find('.form__response').html(data.msg).show();
        }
        if(data.result === "success"){
          if (callback && typeof(callback) == "function"){
            callback();
          };
        }
      }
    });
  }
};

//dom
//scroll to
$(document).on('click','[data-scrollto]',function(e){
  e.preventDefault();
  $("html, body").animate({ scrollTop: $($(this).attr('data-scrollto')).offset().top - $('header').height() }, 400);
});
$(function(){
  dropdown.bind();
  qnt_input.bind();
  modal.bind();
  ajax_cart.bind();
  FastClick.attach(document.body);

  ajax_form.bind($('[data-ajaxform="footer"]'));
});